import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { goToCheckout } from '../lib/checkout';
export function FinalCTA() {
  return <section className="bg-carbon text-white py-12 md:py-16 px-4" data-id="element-57">
      <div className="max-w-2xl mx-auto text-center" data-id="element-58">
        <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-59">
          El próximo domingo podés seguir buscando
          <br data-id="element-60" />
          ejercicios en Google.
        </h2>

        <h3 className="text-xl md:text-2xl font-bold text-sci-orange mb-8" data-id="element-61">
          O podés tener todo resuelto desde hoy.
        </h3>

        <div className="mb-8" data-id="element-62">
          <CountdownTimer variant="large" data-id="element-63" />
        </div>

        <div className="space-y-4 max-w-md mx-auto" data-id="element-64">
          <button onClick={() => goToCheckout('megapack')} className="w-full bg-sci-orange hover:bg-orange-600 text-white font-bold py-4 px-4 rounded-lg transition-colors text-base md:text-lg" data-id="element-65">
            🏆 MEGAPACK COMPLETO ⭐ — $27.990 ARS
            <br data-id="element-66" />→ QUIERO MI CIENCIAS 360 COMPLETO
          </button>

          <button onClick={() => goToCheckout('fq')} className="w-full border-2 border-white text-white hover:bg-white hover:text-carbon font-bold py-3 px-4 rounded-lg transition-colors text-sm md:text-base" data-id="element-67">
            🔬 FÍSICO-QUÍMICA — $18.990 ARS
            <br data-id="element-68" />→ QUIERO FÍSICO-QUÍMICA
          </button>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-3 text-xs md:text-sm text-gray-400" data-id="element-69">
          <span data-id="element-70">🔒 Pago 100% seguro</span>
          <span data-id="element-71">⚡ Acceso en 5 minutos</span>
          <span data-id="element-72">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-73">💳 Mercado Pago | Tarjeta de crédito</span>
        </div>
      </div>
    </section>;
}